import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    CaseAutomaticNotificationTriggerCreateRequest,
    CaseAutomaticNotificationTriggerPatchInBatchRequest,
    CaseAutomaticNotificationTriggerResponse
} from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-trigger/configuration-case-automatic-notification-trigger.dto'

class ConfigurationCaseAutomaticNotificationTriggerService {
    async create(request: CaseAutomaticNotificationTriggerCreateRequest, laboratoryId: number): Promise<CaseAutomaticNotificationTriggerResponse> {
        const response =
            await axios.post<CaseAutomaticNotificationTriggerResponse>(
                `/configuration/laboratories/${laboratoryId}/caseAutomaticNotificationTriggers`,
                request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<CaseAutomaticNotificationTriggerResponse>> {
        const response =
            await axios.put<IResponseAgGrid<CaseAutomaticNotificationTriggerResponse>>(
                `/configuration/laboratories/${laboratoryId}/caseAutomaticNotificationTriggers`,
                filterModel,
                { params })
        return response.data
    }

    async get(laboratoryId: number, caseAutomaticNotificationTriggerId: number): Promise<CaseAutomaticNotificationTriggerResponse> {
        const response =
            await axios.get<CaseAutomaticNotificationTriggerResponse>(
                `/configuration/laboratories/${laboratoryId}/caseAutomaticNotificationTriggers/${caseAutomaticNotificationTriggerId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.delete<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/caseAutomaticNotificationTriggers/batch`,
                { data: request })
        return response.data
    }

    async patch(request: CaseAutomaticNotificationTriggerPatchInBatchRequest[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.patch<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/caseAutomaticNotificationTriggers/batch`,
                request)
        return response.data
    }
}
export const configurationCaseAutomaticNotificationTriggerService = new ConfigurationCaseAutomaticNotificationTriggerService()
